/**
 * LaunchPricingBadge
 * --------------------------------------------------------------------
 * Canonical launch pricing statement rendered on the public homepage
 * hero. Prior promotional copy has been retired per Product Owner
 * canonical-pricing decision — the surface now carries the single
 * controlling JobClose AI launch price so contractors see accurate
 * pricing everywhere, including native shells. This is a factual
 * pricing display only; it contains no purchase mechanism, no
 * external purchase CTA, and no steering language, so it is safe
 * to render on iOS and Android under Strategy A.
 *
 * Canonical launch pricing (locked by Product Owner):
 *   $129/month · 2 full users included · +$20/month per additional user
 * --------------------------------------------------------------------
 */

const LaunchPricingBadge = ({ className = "" }) => {
  return (
    <div
      data-testid="landing-launch-pricing-badge"
      className={`w-full rounded-lg border-l-2 border-[var(--jc-blue)] bg-[#FAF7F2] px-4 py-3 text-sm leading-relaxed text-[var(--jc-text-soft)] ${className}`}
    >
      <p>
        <span className="font-semibold text-[var(--jc-text)]">
          $129/month.
        </span>{" "}
        2 full users included. Additional users are $20/month each.
      </p>
    </div>
  );
};

export default LaunchPricingBadge;
